import React from "react";
import Konark from "../../Assets/Tour/Konark.png";
import Chilika from "../../Assets/Tour/ChilikaDolphin.png";
import JagannathTemple from '../../Assets/Tour/JagannathTemple.png';
import LingarajTemple from '../../Assets/Tour/LingarajTemple.png';
import Dhauli from "../../Assets/Tour/Dhauli.png";
import Jiranga from "../../Assets/Tour/Jiranga.png";
import RamMandir from "../../Assets/Tour/RamMandirTour.png";


const data = [
  {
    id: 1,
    imgSrc: Konark,
    district: "Puri",
    name: "Konark Temple",
    aos: "flip-right",
  },

  {
    id: 2,
    imgSrc: Chilika,
    district: "Ganjam",
    name: "Chilika Lake",
    aos: "flip-right",
  },

  {
    id: 3,
    imgSrc: JagannathTemple,
    district: "Puri",
    name: "Jagannath Temple",
    aos: "flip-right",
    aos: "flip-right"
  },

  {
    id: 4,
    imgSrc: Dhauli,
    district: "Bhubaneswar",
    name: "Dhauli Giri",
    aos: "flip-right"
  },

  {
    id: 5,
    imgSrc: LingarajTemple,
    district: "Bhubaneswar",
    name: "Lingaraj Temple",
    aos: "flip-right"
  },

  {
    id: 6,
    imgSrc: Jiranga,
    district: "Gajapati",
    name: "Jiranga",
    aos: "flip-right"
  },
  
  {
    id: 7,
    imgSrc: RamMandir,
    district: "Bhubaneswar",
    name: "Ram Temple",
    aos: "flip-right"
  },
];

function TopDestinations() {
  return (
    <div className="mx-4 my-10 flex flex-col items-center sm:mx-6 lg:mx-10 xl:mx-16">
      <h1
        className="mb-8 text-center text-3xl font-bold text-[#292929] tracking-wide sm:text-4xl"
        style={{ fontFamily: "DM Sans, sans-serif" }}
      >
        Top Destinations
      </h1>
      <div className="grid w-full grid-cols-2 justify-items-center gap-x-3 gap-y-8 text-center xs:grid-cols-3 sm:grid-cols-4 sm:gap-x-5 lg:grid-cols-5 xl:grid-cols-7 xl:gap-x-4">
        {data.map((data) => (
          <div
            key={data.id}
            className="flex flex-col items-center"
            style={{ fontFamily: "DM Sans, sans-serif" }}
            data-aos={data.aos}
          >
            <img
              src={data.imgSrc}
              alt={data.name}
              className="mb-4 h-28 w-28 rounded-full object-cover sm:h-32 sm:w-32 lg:h-36 lg:w-36"
            />
            <h2 className="text-base font-bold text-[#292929] sm:text-lg">
              {data.name}
            </h2>
            <p className="mb-2 text-sm font-semibold text-[#666666] sm:text-base">{data.district}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default TopDestinations;
